import React, { useEffect, useState } from 'react';
import './reference.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import {
  getFilterData,
  getPaginationOpts,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import { getReferenceInformationData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import UserActionLogDTO from '../../../dto/UserActionLogDTO';
import Grid from '../../../components/base/Grid/Grid';
import { loadInsuranceCompaniesList } from '../actions';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { REFERENCE_INFORMATION_MODULE } from '../../../configs/moduleNames';
import getDefaultSort from '../../../utils/getDefaultSort';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import TextSearchInput from '../../../components/fields/TextInput/TextSearchInput';

export default function ListOfInsuranceCompaniesPage() {
  const dispatch = useDispatch();
  const store = useStore();
  const [selectedRow, setSelectedRow] = useState(null);
  const { updatePeriod } = useSelector(getSystemData);
  const {
    insuranceCompaniesList = [],
    loadingListOfInsuranceCompaniesList,
    insuranceCompaniesListMeta = {},
  } = useSelector(getReferenceInformationData);
  const { formatMessage } = useIntl();
  const {
    getValues, control, watch, setValue,
  } = useForm({ defaultValues: getFilterData('lic-filter', {}) });
  const insuranceCompanyColumns = [
    {
      dataField: 'name',
      text: 'Наименование страховой компании',
      headerClassName: 'company-name-column',
    },
    {
      dataField: 'phone',
      text: 'Телефон',
      headerClassName: 'phone-column',
    },
    {
      dataField: 'address',
      text: 'Адрес головного офиса',
      headerClassName: 'head-office-address-column',
    },
    {
      dataField: 'departments_count',
      text: 'Отделения',
      headerClassName: 'branches-column',
    },
    {
      dataField: 'offices_count',
      text: 'Офисы урегулирования',
      headerClassName: 'settlement-offices-column',
    },
  ];
  const [sort, setSort] = useState(getDefaultSort(insuranceCompanyColumns));
  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(store.getState()[REFERENCE_INFORMATION_MODULE].insuranceCompaniesListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: filterData,
      sort,
    };
    const p1 = dispatch(loadInsuranceCompaniesList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(() => {
    const subscription = watch(values => loadData({ page: 1 }));
    return () => subscription.unsubscribe();
  }, [watch]);
  const DTO = new UserActionLogDTO();

  const handleSelectRow = item => {
    let select = item;
    if (selectedRow && selectedRow.id === item.id) {
      select = null;
    }
    setSelectedRow(select);
  };
  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  return (
    <div className="page lic-page">
      <TimerLoader loading={loadingListOfInsuranceCompaniesList} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.reference.insurance.companies' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
          />
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <Grid
                onDoubleClickByRow={handleSelectRow}
                rowClassFormatter={item => (selectedRow && item.id === selectedRow.id ? 'clickable-table-row selected' : 'clickable-table-row')}
                data={insuranceCompaniesList}
                columns={insuranceCompanyColumns}
                changeSort={changeSort}
                sort={sort}
                name="lic-grid"
                className="lic-grid"
              />
            </div>
          </div>
          <Pagination meta={insuranceCompaniesListMeta} list={insuranceCompaniesList} handleChangeMeta={loadData} />
        </div>
      </div>
    </div>
  );
}
